import React, { useState, useRef } from 'react';
import { CustomSecondaryButton } from '../pages/physician_page/styled';
import { Card, Col } from 'antd';
import { AudioOutlined, DownloadOutlined, PauseOutlined, PlayCircleOutlined } from '@ant-design/icons';
import TermAndCondition from './TermAndCondition';

const WaveformRecorder = ({audioUrl,setAudioUrl,setRecording,recording, getMyProfile, isConsentAccept, profileData}) => {
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const canvasRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const animationIdRef = useRef(null);
  const sourceRef = useRef(null);
  const streamRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);
  const [isModalOpen, setisModalOpen] = useState(false);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    streamRef.current = stream;

    // Web Audio setup
    audioContextRef.current = new (window.AudioContext ||
      window.webkitAudioContext)();
    analyserRef.current = audioContextRef.current.createAnalyser();
    analyserRef.current.fftSize = 2048;
    dataArrayRef.current = new Uint8Array(analyserRef.current.fftSize);

    sourceRef.current = audioContextRef.current.createMediaStreamSource(stream);
    sourceRef.current.connect(analyserRef.current);

    // MediaRecorder setup
    mediaRecorderRef.current = new MediaRecorder(stream);
    audioChunksRef.current = [];

    mediaRecorderRef.current.ondataavailable = (e) => {
      if (e.data.size > 0) {
        audioChunksRef.current.push(e.data);
      }
    };

    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
      setAudioUrl(URL.createObjectURL(blob));
    };

    mediaRecorderRef.current.start();
    setRecording(true);
    setIsPaused(false);
    drawWaveform(); // Start waveform drawing
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    streamRef.current.getTracks().forEach((track) => track.stop());
    audioContextRef.current.close();
    cancelAnimationFrame(animationIdRef.current);
    setRecording(false);
    setIsPaused(false);
  };

  const pauseRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
      mediaRecorderRef.current.pause();
      setIsPaused(true);
      // Pause animation
      cancelAnimationFrame(animationIdRef.current);
    }
  };

  const resumeRecording = () => {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'paused') {
      mediaRecorderRef.current.resume();
      setIsPaused(false);
      // Resume animation
      drawWaveform();
    }
  };

  const drawWaveform = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const draw = () => {
      animationIdRef.current = requestAnimationFrame(draw);
      analyserRef.current.getByteTimeDomainData(dataArrayRef.current);

      ctx.fillStyle = '#f0f2f5';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.lineWidth = 2;
      ctx.strokeStyle = '#000';
      ctx.beginPath();

      const sliceWidth = canvas.width / analyserRef.current.fftSize;
      let x = 0;

      for (let i = 0; i < analyserRef.current.fftSize; i++) {
        const v = dataArrayRef.current[i] / 128.0;
        const y = (v * canvas.height) / 2;

        if (i === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }

        x += sliceWidth;
      }

      ctx.lineTo(canvas.width, canvas.height / 2);
      ctx.stroke();
    };

    draw();
  };

  const saveRecording = () => {
    if (!audioUrl) return;
    const a = document.createElement('a');
    a.href = audioUrl;
    a.download = 'recording.mp4'; // It's really WebM format
    a.click();
  };

  const startNewRecording = () => {
    setAudioUrl(null);
  };

  return (
    <>
    {isModalOpen && (
      <TermAndCondition
        isOpen={isModalOpen}
        setOpen={setisModalOpen}
        getMyProfile={getMyProfile}
        profileData={profileData}
      />
    )}
    <Card type="inner" className="mb-24">
      <Col className="mb-10">
        {audioUrl && (
          <div className="w-100 custom-recoeding-field d-grid">
            <div className=" d-flex justify-content-center align-item-end">
              <audio controls src={audioUrl}></audio>
            </div>
          </div>
        )}
        {!audioUrl && (
          <>
            {!recording ? (
              <div className="w-100 custom-recoeding-field d-grid">
                <div className="h-full d-flex justify-content-center align-item-end">
                  <AudioOutlined
                    className="font-30"
                    style={{ color: '#8a3ef4' }}
                  />
                </div>
                <div className="font-16 text-secondry">
                  Audio Waveform Will Appear Here
                </div>
              </div>
            ) : (
              <div className="w-100 custom-recoeding-field d-grid">
                {/* <div className="w-100 d-flex justify-content-center align-item-end"> */}
                <canvas
                  ref={canvasRef}
                  width={600}
                  height={100}
                  style={{
                    border: 'none',
                    background: 'transparent',
                  }}
                />
                {/* </div> */}
              </div>
            )}
          </>
        )}
      </Col>
      <Col className="d-flex justify-content-center">
        <div className="d-flex justify-content-center gap-12">
          {!recording && !audioUrl && (
            <CustomSecondaryButton onClick={() => {
              if(isConsentAccept){
                startRecording();
              } else {
                setisModalOpen(true)
              }
            }}
            >
              <AudioOutlined />
              Start Recording
            </CustomSecondaryButton>
          )}
          
          {recording && (
            <>
              {!isPaused ? (
                <CustomSecondaryButton onClick={pauseRecording}>
                  <PauseOutlined /> Pause
                </CustomSecondaryButton>
              ) : (
                <CustomSecondaryButton onClick={resumeRecording}>
                  <PlayCircleOutlined /> Resume
                </CustomSecondaryButton>
              )}
              <CustomSecondaryButton onClick={stopRecording}>
                Stop Recording
              </CustomSecondaryButton>
            </>
          )}

          {audioUrl && (
            <>
              <CustomSecondaryButton onClick={saveRecording}>
                <DownloadOutlined /> Download
              </CustomSecondaryButton>
              <CustomSecondaryButton onClick={startNewRecording}>
                Record Again
              </CustomSecondaryButton>
            </>
          )}
        </div>
      </Col>
    </Card>
    </>
  );
};

export default WaveformRecorder;
